export const CREATE_CATEGORY = 'CREATE_CATEGORY'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_UNIQUE_CATEGORIE = 'GET_UNIQUE_CATEGORIE'
export const GET_SUBS = 'GET_SUBS'


